import React from 'react';
import { MarketIQLayout } from '../components/MarketIQLayout';
import { MarketIQNav } from '../components/MarketIQNav';
import { PorkCutoutChart } from '../components/PorkCutoutChart';
import { PorkCutoutTable } from '../components/PorkCutoutTable';
export function MarketIQPork() {
  return <MarketIQLayout activeSection="pork" data-id="element-509" data-mp="1w6if6npfljw8">
      <PorkCutoutChart data-id="element-510" data-mp="1w7jpgpymi2cw" />
      <MarketIQNav current="pork" data-id="element-511" data-mp="1w57bsozwee5n" />
      <PorkCutoutTable data-id="element-512" data-mp="18gxvg2lgeilw" />
    </MarketIQLayout>;
}